const handleFieldChange = (dataFieldName, updateFormData, setIsRequiredAdditionalInformation) => {
    switch (dataFieldName) {
        case "isRequireAdditionalInformation": {
            const { isRequireAdditionalInformation } = updateFormData;
            setIsRequiredAdditionalInformation(isRequireAdditionalInformation)
            break;
        }
        default:
            break;
    }
};

export default handleFieldChange;


